export const TOKEN_KEY = '@bugal-token';
export const TOKEN_IMPERSONATE_KEY = '@bugal-impersonate-token';
export const REFRESH_TOKEN_KEY = '@bugal-refresh-token';

export const IsAuthenticated = () => localStorage.getItem(TOKEN_KEY) !== null;
export const GetToken = () => {
  return GetImpersonateToken() || localStorage.getItem(TOKEN_KEY);
};
export const GetRefreshToken = () => localStorage.getItem(REFRESH_TOKEN_KEY);

export const SetToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const SetRefreshToken = (refreshToken: string) => {
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
};

export const Logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(TOKEN_IMPERSONATE_KEY);
};

export const GetImpersonateToken = () => localStorage.getItem(TOKEN_IMPERSONATE_KEY);
export const IsImpersonated = () => localStorage.getItem(TOKEN_IMPERSONATE_KEY) !== null;

export const SetImpersonateToken = (token: string) => {
  localStorage.setItem(TOKEN_IMPERSONATE_KEY, token);
};

export const LeaveImpersonate = () => {
  localStorage.removeItem(TOKEN_IMPERSONATE_KEY);
};
